import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { LockerService } from '../../../../shared/services/pubServices/lockers.service';
import { Page, PageClass } from '../../../../shared/filters/filters';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'pub-gateway-component',
  templateUrl: './content-component.html',
  styleUrls: ['./content-component.scss'],
})

export class contentsComponent implements OnInit {
  integ1: string;
  integ2: string;
  integ3: string;
  integ4: string;

  contentData: any;
  page = new Page();
  filter = new PageClass();
  offsetNumber: number;

  selected : any[] = [];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private _router: Router, private lockerService: LockerService) {
    this.page.pageNumber = 1;
    this.page.size = 10;
    this.offsetNumber = 0;
  }

  ngOnInit() {
    //this.integ1 = `<script src="//cdn.inniver.com/gateway.js"></script>`;
    this.integ1 = `<script src="https://cdn.inniver.com/InniverGateway.js"></script>`;

    this.setPage({  offset: this.lockerService.getSelected(2) });
   }

  setPage(pageInfo){
    this.filter.pageNumber = pageInfo.offset+1;
    this.filter.pageSize = 10;
    this.lockerService.saveSelected(2, pageInfo.offset);

    this.lockerService.getAllContentLocker(this.filter)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.page.size = data.pageSize;
      this.contentData = data.data;
      this.selected = [this.contentData[0]];
      this.integ2 = `<a href="#InniverGate/` + this.selected[0].hashCode + `">Click to open gateway</a>`;
      this.integ3 = `new InniverGateway("` + this.selected[0].hashCode + `").start();`;
      this.integ4 = `new InniverGateway("` + this.selected[0].hashCode + `", "your_blocked_content_name").start();`;
       },
     error => {
       console.log(error);
     });
  }

  onSelect({ selected }) {
    this.integ2 = `<a href="#InniverGate/` + selected[0].hashCode + `">Click to open gateway</a>`;
    this.integ3 = `new InniverGateway("` + selected[0].hashCode + `").start();`;
    this.integ4 = `new InniverGateway("` + this.selected[0].hashCode + `", "your_blocked_content_name").start();`;
  }

  onEdit(){
    this._router.navigate(["/pub/gateway/" + this.selected[0].lockerId]);
  }

  onNew(){
    this._router.navigate(["/pub/gatewaynew"]);
  }

  onDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {

        this.lockerService.deleteContentLocker(this.selected[0].lockerId)
        .subscribe(
          response => {
            Swal.fire(
            'Deleted!',
            'Your gateway has been deleted.',
            'success'
            )
            this.setPage({ offset: 0 });
          },
          error => {
            console.log(error);
          });

      }
    })
  }
}
